/* global axios */
import ApiClient from './ApiClient';

const appendFormValue = (formData, key, value) => {
  if (Array.isArray(value)) {
    value.forEach(item => appendFormValue(formData, `${key}[]`, item));
    return;
  }

  if (value && typeof value === 'object' && !(value instanceof File)) {
    Object.entries(value).forEach(([nestedKey, nestedValue]) =>
      appendFormValue(formData, `${key}[${nestedKey}]`, nestedValue)
    );
    return;
  }

  if (value !== null && value !== undefined) {
    formData.append(key, value);
  }
};

const toFormData = data => {
  const formData = new FormData();
  const {
    attachments = [],
    audience = [],
    template_params: templateParams = {},
    ...campaign
  } = data;

  Object.entries(campaign).forEach(([key, value]) => {
    appendFormValue(formData, `campaign[${key}]`, value);
  });

  Object.entries(templateParams).forEach(([key, value]) => {
    appendFormValue(formData, `campaign[template_params][${key}]`, value);
  });

  audience.forEach(audienceItem => {
    Object.entries(audienceItem).forEach(([key, value]) => {
      appendFormValue(formData, `campaign[audience][][${key}]`, value);
    });
  });

  attachments.forEach(file => formData.append('campaign[attachments][]', file));

  return formData;
};

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  previewAudience(data) {
    return axios.post(`${this.url}/preview_audience`, data);
  }

  create(data) {
    if (!data.attachments?.length) {
      return super.create(data);
    }

    return axios.post(this.url, toFormData(data));
  }
}

export default new CampaignsAPI();
